import React, {FC} from 'react';
import styled from 'styled-components';

import {Trans} from '../../../../../libs/shared/helpers/src/internationalization/react';
import {boxShadow} from '../../../../../libs/shared/ui/src/theme/themeStyleHelpers';
import {computeJobProgress} from '../../../../helpers/jobHelpers';
import {SyncJobModel} from '../../../../models/api/jobModel';
import {BannerIcon} from '../../../common/banners/bannerIcon';
import {BannerProgress} from '../../../common/banners/bannerProgress';
import {BannerSecondaryText} from '../../../common/banners/bannerSecondaryText';
import {BannerText} from '../../../common/banners/bannerText';

/*
 * Props.
 */

interface CrmSyncingBannerProps {
  job?: SyncJobModel;
}

/*
 * Style.
 */

const StyledBannerDiv = styled.div`
  position: relative;
  overflow: hidden;

  display: grid;
  grid-template-columns: auto 1fr max-content;
  grid-template-areas: 'icon content action';
  grid-column-gap: 10px;
  align-items: center;

  height: 34px;
  padding: 0 12px;

  border-radius: 8px;
  background-color: ${(p) => p.theme.bannerBackground};
  ${(p) => boxShadow(p.theme, `0 2px 15px ${p.theme.alphas.black50}`)};

  pointer-events: all;
`;

/*
 * Component.
 */

export const CrmSyncingBanner: FC<CrmSyncingBannerProps> = (props) => {
  const {job} = props;

  if (!job) {
    return null;
  }

  const progress = computeJobProgress(job);

  return (
    <StyledBannerDiv>
      <BannerProgress progress={progress} />
      <BannerIcon iconName="repeatCircleSmall" shouldRotate />
      <BannerText>
        <Trans id="crm-dialog-sync-in-progress">Sync in progress...</Trans>
      </BannerText>
      {/* TODO: Expose a cancel option instead of showing the percentage. */}
      <BannerSecondaryText>
        <Trans id="crm-dialog-sync-in-progress-percentage">{Math.floor(100 * progress)}%</Trans>
      </BannerSecondaryText>
    </StyledBannerDiv>
  );
};
